import { render } from "./ProfileNotValidated.vue?vue&type=template&id=24fa955f&ts=true"
import script from "./ProfileNotValidated.vue?vue&type=script&lang=ts"
export * from "./ProfileNotValidated.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/tawa.digital.dashboard/tawa.digital.dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__